module.exports = __webpack_public_path__ + "img/symbol_1.dca9716c.png";